export const GET_NOTICE = 'GET_NOTICE';
export const GET_NOTICE_SUCCESS = 'GET_NOTICE_SUCCESS';
export const GET_NOTICE_DETAIL = 'GET_NOTICE_DETAIL';
export const GET_NOTICE_DETAIL_SUCCESS = 'GET_NOTICE_DETAIL_SUCCESS';
export const UPDATE_NOTICE_LIST = 'UPDATE_NOTICE_LIST';

